import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Earn } from "@faire/web/slate/icons/foundation/Earn";
import React from "react";
import { AddPaymentMethodIA } from "../instantAnswers/invoicesAndPayments-addPaymentMethod";
import { ChangeDefaultPaymentMethodIA } from "../instantAnswers/invoicesAndPayments-changeDefaultPaymentMethod";
import { Net60BasicsIA } from "../instantAnswers/invoicesAndPayments-net60Basics";
import { PaymentProcessingErrorIA } from "../instantAnswers/invoicesAndPayments-paymentProcessingError";
import { RefundsIA } from "../instantAnswers/invoicesAndPayments-refunds";
import { RequestCreditLimitIncreaseIA } from "../instantAnswers/invoicesAndPayments-requestCreditLimitIncrease";
import { ViewOrUpdatePaymentMethodsIA } from "../instantAnswers/invoicesAndPayments-viewOrUpdatePaymentMethods";
export var usePaymentsRetailerNodes = function usePaymentsRetailerNodes() {
  var _articles$PaymentsAnd;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    Payments: {
      id: "Payments",
      label: strictLocalize({
        id: "G0P64D",
        defaultMessage: [{
          "type": 0,
          "value": "Paiements"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Earn, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      children: ["PaymentMethods", "PaymentIssues", "PaymentTerms", "Refunds"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "SwyOSc",
        defaultMessage: [{
          "type": 0,
          "value": "Problème de paiements"
        }]
      })
    },
    PaymentTerms: {
      id: "PaymentTerms",
      label: strictLocalize({
        id: "zUl0jl",
        defaultMessage: [{
          "type": 0,
          "value": "Conditions de paiement"
        }]
      }),
      children: ["AboutPaymentTerms", "RequestCreditLimitIncrease"],
      level: 2
    },
    PaymentMethods: {
      id: "PaymentMethods",
      label: strictLocalize({
        id: "A0iGAk",
        defaultMessage: [{
          "type": 0,
          "value": "Modes de paiement"
        }]
      }),
      children: ["AddPaymentMethod", "ChangeDefaultPaymentMethod", "EditPaymentMethods"],
      level: 2
    },
    PaymentIssues: {
      id: "PaymentIssues",
      label: strictLocalize({
        id: "Y8ndwT",
        defaultMessage: [{
          "type": 0,
          "value": "Problèmes de paiement"
        }]
      }),
      children: ["PaymentProcessingError"],
      level: 2
    },
    Refunds: {
      id: "Refunds",
      label: strictLocalize({
        id: "zHQ3fC",
        defaultMessage: [{
          "type": 0,
          "value": "Remboursements"
        }]
      }),
      instantAnswer: RefundsIA(strictLocalize),
      articles: [articles.ReturnsAndRefunds.MAKE_A_RETURN],
      level: 2
    },
    AboutPaymentTerms: {
      id: "AboutPaymentTerms",
      label: strictLocalize({
        id: "mtO9t+",
        defaultMessage: [{
          "type": 0,
          "value": "À propos des conditions de paiement"
        }]
      }),
      instantAnswer: Net60BasicsIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.NET_60_TERMS],
      level: 3
    },
    RequestCreditLimitIncrease: {
      id: "RequestCreditLimitIncrease",
      label: strictLocalize({
        id: "hbKQGg",
        defaultMessage: [{
          "type": 0,
          "value": "Demander une augmentation du montant disponible dans les conditions de paiement"
        }]
      }),
      instantAnswer: RequestCreditLimitIncreaseIA(strictLocalize),
      articles: [(_articles$PaymentsAnd = articles.PaymentsAndInvoices.NET_60_TERMS) === null || _articles$PaymentsAnd === void 0 ? void 0 : _articles$PaymentsAnd.atSection("2")],
      level: 3
    },
    AddPaymentMethod: {
      id: "AddPaymentMethod",
      label: strictLocalize({
        id: "QAav+n",
        defaultMessage: [{
          "type": 0,
          "value": "Ajouter un mode de paiement"
        }]
      }),
      instantAnswer: AddPaymentMethodIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.HOW_DO_I_PAY_FOR_ORDERS, articles.PaymentsAndInvoices.CHANGE_MY_PAYMENT_METHOD],
      level: 3
    },
    ChangeDefaultPaymentMethod: {
      id: "ChangeDefaultPaymentMethod",
      label: strictLocalize({
        id: "tEqTiy",
        defaultMessage: [{
          "type": 0,
          "value": "Modifier le mode de paiement par défaut"
        }]
      }),
      instantAnswer: ChangeDefaultPaymentMethodIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.CHANGE_MY_PAYMENT_METHOD],
      level: 3
    },
    EditPaymentMethods: {
      id: "EditPaymentMethods",
      label: strictLocalize({
        id: "iRXt3F",
        defaultMessage: [{
          "type": 0,
          "value": "Modifier les modes de paiement"
        }]
      }),
      instantAnswer: ViewOrUpdatePaymentMethodsIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.HOW_DO_I_PAY_FOR_ORDERS, articles.PaymentsAndInvoices.CHANGE_MY_PAYMENT_METHOD],
      level: 3
    },
    PaymentProcessingError: {
      id: "PaymentProcessingError",
      label: strictLocalize({
        id: "j+h7IP",
        defaultMessage: [{
          "type": 0,
          "value": "Erreur de traitement du paiement"
        }]
      }),
      instantAnswer: PaymentProcessingErrorIA(strictLocalize),
      level: 3
    }
  };
};